import React, { ReactNode } from 'react'
import { Box } from 'shared-components/material/core'

export default function DetailWrapper({ children }: { children: ReactNode[] | ReactNode }) {
  return (
    <Box sx={{ flexGrow: 1, maxWidth: '1440px' }}>{children}</Box>
  )
}
